import React from 'react';
import { fleetTripHistoryRoute } from '@/modules/administration/fleet-trip-history/routes';
import { createRoute } from '@tanstack/react-router';

export const fleetTripHistoryDetailRoute = createRoute({
  getParentRoute: () => fleetTripHistoryRoute,
  path: '$fleetId',
  wrapInSuspense: true,
  component: React.lazy(async () => await import('@/app/routes/Admin/FleetTripHistory/Details')),
});
